import Vue from 'vue';
import {permissions} from './permissions';
import UserService from '@services/user.service';

const state = {
    user: false,
    permissions: [],
};

const mutations = {
    ['SET_USER'](state, data) {
        state.user = data;
    },
    ['SET_PERMISSIONS'](state, data) {
        state.permissions = data;
    },
};
const actions = {
    ['GET_USER_PERMISSIONS']({commit, getters}) {
        UserService.permissions().then(res => {
            commit('SET_PERMISSIONS', res);
        });
    },
    ['GET_USER_PROFILE']({commit}) {
        UserService.profile().then(res => {
            commit('SET_USER', res);
        });
    },
};
const getters = {
    ...permissions,
    user: state => {
        return state.user;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
